<template>
  <!-- Cookie-notice root -->
  <div
    role="region"
    aria-label="Cookie policy notice"
  >
    <!-- ───────── Desktop / large-screen dialog ───────── -->
    <div v-if="!isApp && !$vuetify.breakpoint.mdAndDown">
      <v-dialog
        v-model="cookiesVisibility"
        width="270"
        transition="dialog-bottom-transition"
        aria-modal="true"
        aria-labelledby="cookie-dialog-heading"
      >
        <v-card>
          <v-card-title
            id="cookie-dialog-heading"
            class="text-subtitle-1"
            role="heading"
            aria-level="2"
          >
            {{ $t('components.cookies.title') }}
          </v-card-title>

          <v-card-text>
            {{ $t('components.cookies.info') }}
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-btn
              color="primary"
              :aria-label="$t('components.cookies.buttons.read')"
              @click="toRead()"
            >
              {{ $t('components.cookies.buttons.read') }}
            </v-btn>

            <v-btn
              color="primary"
              class="accent--text"
              :aria-label="$t('components.cookies.buttons.ok')"
              @click="cookiesVisibility = 0"
            >
              {{ $t('components.cookies.buttons.ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!-- ───────── Mobile / in-app banner ───────── -->
    <v-flex
      v-if="isApp || $vuetify.breakpoint.mdAndDown"
      xs12
      sm12
      md12
      lg12
    >
      <v-alert
        v-model="cookiesVisibility"
        dismissible
        border="left"
        type="info"
        color="secondary"
        class="mt-12 mb-0"
        aria-live="polite"
      >
        {{ $t('components.cookies.info') }}
        <router-link
          tag="a"
          :to="tcPolicy"
          class="ml-1 underline"
          aria-label="Read the full cookie policy"
        >
          {{ $t('components.cookies.buttons.link') }}
        </router-link>
      </v-alert>

      <!-- Floating re-open FAB after dismissal -->
      <div class="text-center">
        <v-btn
          v-if="!cookiesVisibility"
          color="accent"
          fab
          small
          aria-label="Re-open cookie notice"
          @click="cookiesVisibility = 1"
        >
          <v-icon aria-hidden="true">
            fal fa-cookie-bite
          </v-icon>
          <span class="sr-only">Open cookie notice</span>
        </v-btn>
      </div>
    </v-flex>
  </div>
</template>

<script>
import links from "@/constants/links";
import { CookieSet, CookieGet } from "@/utils/cookie.utils";

export default {
    name: "CookiesNotification",
    data() {
        return {
            cookiesVisibility: 0
        }
    },
    computed: {
      tcPolicy() {
        return links?.routes?.tcPolicy || '/';
      },
      isApp() {
        return this.$route.query.isApp === 'true';
      },
    },
    watch: {
        cookiesVisibility(newValue) {
            // Convert the newValue from bool to true=false than from bool to int using unary(+)
            CookieSet("agreedCookies", +!newValue);
        }
    },
    beforeMount() {
        const agreedCookie = CookieGet("agreedCookie");
        this.cookiesVisibility =
            agreedCookie == "" ? 1 : !parseInt(agreedCookie);
    },
    methods: {
        toRead() {
            this.cookiesVisibility = false;
            this.$router.push(this.tcPolicy);
        }
    }
};
</script>

<style scoped>
/* Component-specific styles */
</style>
